/**
 * Analytics Provider Component
 * Initializes Google Analytics and PWA analytics tracking
 * Place this inside BrowserRouter and AuthProvider
 */

import React from 'react';
import { useAnalyticsInitialization } from '../../hooks/useAnalyticsTracking';

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

/**
 * Provider component that initializes analytics tracking.
 * Automatically tracks:
 * - Page views on route change
 * - User properties when authenticated
 * - Network status changes
 */
export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ children }) => {
  useAnalyticsInitialization();
  return <>{children}</>;
};

export default AnalyticsProvider;
